// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/urgency-call-procedure.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/urgency-call-procedure/urgency-call-procedure.js';
import g1 from '../lessons/air-law/urgency-call-procedure/urgency-receipt-duties.js';

mount([g0, g1]);
